import { SecurityPlusKeys } from "CustomHooks/usePinAuth";

export const BOOKKEEPING_RIGHT: SecurityPlusKeys = "dashboard.bookkeeping.read";

export const BOOKKEEPING_SECTIONS = [
  {
    id: "customer-invoices",
    label: "Customer Invoices",
    right: "dashboard.settings.read",
  },
  { id: "hyperline", label: "Hyperline", right: "dashboard.settings.read" },
  { id: "add-ons", label: "Add Ons", right: "none" },
  {
    id: "vouchers",
    label: "Voucher payments and redemptions",
    right: "dashboard.voucher.read",
  },
  // Only listed for restaurants with the Shop app.
  { id: "shop", label: "Shop invoices", right: "none", app: "shop" },
] as const;

export type BookkeepingSection = typeof BOOKKEEPING_SECTIONS[number]["id"];

export const bookkeepingPath = (
  restaurantId: string,
  section: BookkeepingSection = "customer-invoices"
) => `/${restaurantId}/bookkeeping/${section}`;
